import React from 'react'
import { TaskStatus as TaskStatusEntries } from '@ztechapps/common.contract'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

type TaskStatusProps = { status: string }

export const TaskStatusBadge = ({ status }: TaskStatusProps) => (
  <StatusColorBadge status={status} color={findStatus(TaskStatusEntries, status)} />
)

export const TaskStatus = ({ status }: TaskStatusProps) => (
  <StatusColorDot value={status} color={findStatus(TaskStatusEntries, status)} />
)
